import React from 'react';

const ChartIcon = ({ width = 20, height = 20, fill = "white" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.874 3.15009C12.8407 3.35836 12.8242 3.56681 12.8242 3.77509C12.8242 5.65009 14.3413 7.16571 16.208 7.16571C16.4162 7.16569 16.6161 7.14237 16.8242 7.10907V13.8327C16.8242 16.6585 15.1576 18.3337 12.3242 18.3337H6.16699C3.33283 18.3337 1.66602 16.6585 1.66602 13.8327V7.66669C1.66611 4.8335 3.33291 3.15009 6.16699 3.15009H12.874ZM13.042 8.21649C12.8162 8.1915 12.5922 8.29204 12.458 8.47528L10.4414 11.0837L8.13281 9.26727C7.99115 9.15894 7.82389 9.11598 7.65723 9.13348C7.49167 9.15856 7.34196 9.24943 7.24121 9.38251L4.77539 12.5915L4.72461 12.6667C4.58294 12.9325 4.64941 13.2745 4.89941 13.4587C5.01593 13.5336 5.14078 13.5836 5.28223 13.5837C5.47472 13.592 5.65775 13.4912 5.77441 13.3337L7.86621 10.6413L10.2412 12.4255L10.3164 12.4743C10.583 12.6158 10.9158 12.5501 11.1074 12.2995L13.5156 9.19208L13.4824 9.20868C13.6157 9.02541 13.6414 8.79195 13.5498 8.58368C13.459 8.37538 13.2578 8.2332 13.042 8.21649ZM16.3242 1.66669C17.4326 1.66669 18.333 2.56714 18.333 3.67548C18.3328 4.7836 17.4324 5.68329 16.3242 5.68329C15.2161 5.68317 14.3167 4.78353 14.3164 3.67548C14.3164 2.56721 15.216 1.6668 16.3242 1.66669Z"
      fill={fill}
    />
  </svg>
);

export default ChartIcon;